export const TID = {
  nav: {
    logo: "nav-logo",
    linkServices: "nav-link-services",
    linkWork: "nav-link-work",
    linkProcess: "nav-link-process",
    linkContact: "nav-link-contact",
    cta: "nav-cta-button",
  },
  hero: {
    section: "hero-section",
    headline: "hero-headline",
    subtitle: "hero-subtitle",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
    canvas: "hero-canvas",
  },
  marquee: "logo-marquee",
  services: {
    section: "services-section",
    card: (k) => `service-card-${k}`,
  },
  work: {
    section: "work-section",
    card: (k) => `work-card-${k}`,
  },
  process: {
    section: "process-section",
    step: (k) => `process-step-${k}`,
  },
  testimonials: {
    section: "testimonials-section",
    item: (k) => `testimonial-${k}`,
  },
  contact: {
    section: "contact-section",
    name: "contact-input-name",
    email: "contact-input-email",
    company: "contact-input-company",
    budget: "contact-select-budget",
    message: "contact-input-message",
    submit: "contact-submit-button",
    success: "contact-success",
  },
  footer: "site-footer",
};
